import script from "./ServiceCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCalendar.vue?vue&type=style&index=0&id=46cbe275&lang=css"

const __exports__ = script;

export default __exports__